class ServerValidator {
  constructor($validator) {
    this.errors = {};
    this.$validator = $validator;

    $validator.extend('server', {
      getMessage: (name, [field]) => this.getError(field, name),
      validate: (value, [field]) => !this.hasError(field)
    });
  }

  hasError(field) {
    return field in this.errors;
  }

  getError(field, name) {
    return name
      ? this.errors[field][0].replace(field, name)
      : this.errors[field][0];
  }

  set(errors) {
    this.errors = errors || {};
  }

  async validateAll(errors) {
    this.set(errors);
    await this.$validator.validateAll();
  }

  clear() {
    this.errors = {};
  }
}

export default {
  beforeCreate() {
    this.$serverValidator = new ServerValidator(this.$validator);
  }
};
